import { ViewportPortal } from "@xyflow/react"
import type { FlowGuide } from "@/lib/flow-alignment-guides"

export function FlowAlignmentGuides({ guides }: { guides: FlowGuide[] }) {
  if (guides.length === 0) return null
  return (
    <ViewportPortal>
      <svg className="pointer-events-none absolute top-0 left-0 overflow-visible" style={{ zIndex: 1000 }} aria-hidden>
        {guides.map((guide) => {
          const vertical = guide.orientation === "vertical"
          return (
            <line
              key={guide.orientation}
              x1={vertical ? guide.at : guide.from}
              y1={vertical ? guide.from : guide.at}
              x2={vertical ? guide.at : guide.to}
              y2={vertical ? guide.to : guide.at}
              stroke="var(--ui-text-muted)"
              strokeWidth={1}
              vectorEffect="non-scaling-stroke"
            />
          )
        })}
      </svg>
    </ViewportPortal>
  )
}
